import styled, { css } from 'styled-components';
type WrapperProps = {
  status:
    | 'aberta'
    | 'alto'
    | 'paga'
    | 'cancelada'
    | 'vencida'
    | 'venda'
    | 'average'
    | 'high'
    | 'success'
    | 'error'
    | string
    | boolean;
};

const wrapperModifiers = {
  linearGradient: () => css`
    background: linear-gradient(
      141deg,
      rgba(162, 86, 188, 1) 35%,
      rgba(248, 46, 82, 1) 100%
    );
  `,
};
const wrapperModifiersKenloSigatureGift = {
  linearGradient: () => css`
    background: linear-gradient(
      141deg,
      rgba(162, 86, 188, 1) 35%,
      rgba(247, 110, 133, 1) 100%
    );
  `,
};
export const Wrapper = styled.div<WrapperProps>`
  ${({ theme, status }) => css`
    border-radius: 8px;
    display: flex;
    width: fit-content;
    flex-direction: row;
    align-items: center;
    padding: 4px 8px;
    gap: 5px;
    height: fit-content;
    background: ${(status === 'aberta' &&
      theme.colors.feedback.feedbackAlert10) ||
    (status === 'paga' && theme.colors.feedback.feedbackSuccess60) ||
    (status === 'cancelada' && theme.colors.feedback.feedbackError15) ||
    (status === 'vencida' && theme.colors.feedback.feedbackError15) ||
    (status === 'venda' && theme.colors.neutral.neutral5) ||
    (status === 'average' && '#F1E6F5') ||
    (status === 'high' && theme.colors.neutral.neutral160) ||
    (status === 'success' && theme.colors.feedback.feedbackSuccess20) ||
    (status === 'error' && theme.colors.feedback.feedbackAlert70) ||
    (status === 'lais-alto' && '#8169B2') ||
    (status === 'lais-médio' && '#DAC9FF') ||
    (status === 'lais-baixo' && '#DEEDF9') ||
    (status === 'lais-null' && '#F1E6F5') ||
    (status === 'quali' && '#DEEDF9')};
    ${status === 'alto' && wrapperModifiers.linearGradient()}
    ${status === 'kenloSignatureGift' &&
    wrapperModifiersKenloSigatureGift.linearGradient()}
  `}
`;
export const Text = styled.span<{ color?: string; fontWeight?: string }>`
  ${({ theme, color, fontWeight }) => css`
    font-size: 12px;
    font-weight: ${fontWeight || theme.font.bold};
    color: ${color || theme.colors.neutral.neutral120};
    line-height: 16px;
  `}
`;
